import i18n from 'i18next';

import { RateSource } from '../types/rate-source';

/**
 * Constant representing null/empty value in option sets
 */
export const NULL_OPTION_KEY = '__NULL__';

/**
 * Gets localized label for rate source
 */
export const getRateSourceLabel = (value: RateSource | null): string => {
  if (value === null) {
    return i18n.t('common:table.noValue');
  }

  switch (value) {
    case RateSource.UserExternalRate:
      return i18n.t('common:rates.userExternalRate');
    case RateSource.FlatRate:
      return i18n.t('common:rates.projectFlatRate');
    case RateSource.ProjectRateCard:
      return i18n.t('common:rates.projectRateCard');
    case RateSource.SeniorityBasedRate:
      return i18n.t('common:rates.seniorityBasedRate');
    case RateSource.RoleBasedRate:
      return i18n.t('common:rates.roleBasedRate');
    case RateSource.GlobalDefaultRate:
      return i18n.t('common:rates.globalDefaultRate');
    case RateSource.Custom:
      return i18n.t('common:rates.custom');
    default:
      return i18n.t('common:table.noValue');
  }
};
